import React, {useEffect, useMemo, useRef, useState} from "react";
import styles from './index.module.scss'
import { Button, message, Modal, Radio, Progress } from 'antd'
import { useIntl } from 'react-intl'
import html2canvas from 'html2canvas'
import { PDFDocument } from 'pdf-lib'
import hmLogo from '../../assets/img/hm_logo.png'
import bstLogo from '../../assets/img/bst.png'


let jsPDF = (window as any).jspdf.jsPDF
const Pdfcon: React.FC<any> = (props) => {
  const intl = useIntl()
  const { list, setOpen, colSelect, title, inlogo, dph, partnameData, partlangkey, shownum } = props

  const [loading, setLoading] = useState<boolean>(false)
  const [progress, setProgress] = useState<number>(0)

  // const [shownum, setShownum] = useState<number>(2)
  let logo = inlogo
  let origin = window.location.origin
  if(origin.includes("webtest.maiqipei.com") || origin.includes("gzhmqy.maiqipei.com") || origin.includes("gzhmqy.com") || origin.includes("300")) {
    logo = hmLogo
  }
  if(origin.includes("bmtsr.maiqipei.com") || origin.includes("bmtsr.xiaomaiqipei.com")) {
    logo = bstLogo
  }
  
  let isdp: boolean = false
  if(origin.includes("dpatp")) {
    isdp = true
  }

  // 判断是否是森配
  let isSen = false
  if(origin.includes("senp.maiqipei.com") || origin.includes("senp.xiaomaiqipei.com") || origin.includes("300")) {
    isSen = true
  }

  // 判断是否是恒铭网站
  let ishm = false
  if(origin.includes("webtest.maiqipei.com") || origin.includes("gzhmqy.maiqipei.com") || origin.includes("gzhmqy.com") || origin.includes("300")) {
    ishm = true
  }
  
  

  const classList: any = useMemo(() => {
    let _result: any = {}
    let result: any = []
    if(ishm) return list
    list.forEach((item: any) => {
      if(_result[item.main_group]) {
        _result[item.main_group].push(item)
      }else  {
        _result[item.main_group] = [item]
      }
    })
    let num = 4
    if(isdp) num = 3
    Object.keys(_result).forEach((key) => {
      let extraLen = num - (_result[key].length % num)
      _result[key] = [..._result[key], ...Array.from({ length: extraLen !== num ? extraLen: 0 }, () => ({main_group: key}))]
      result = [...result, ..._result[key]]
    })
    return result
  },[list])

  const downloadFile = (url: any) => {
    let a: any = document.createElement("a")
    a.setAttribute("id", url)
    a.setAttribute("download", title ? title.split(">").slice(0,3).join("-") : '')
    a.href = url
    a.click()
    a.remove()
    message.success(intl.formatMessage({ id: '导出成功' }))
  }
  const mergePDFsToBase64 = async (dataList: any) => {
    const mergedPdf = await PDFDocument.create()
    for(let pdfData of dataList) {
      const pdf: any = await PDFDocument.load(pdfData)
      const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices())
      copiedPages.forEach((page: any) => {
        mergedPdf.addPage(page)
      })
    }
    const mergedPdfBytes = await mergedPdf.save();
    const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
    const mergedpdfBase64 = URL.createObjectURL(blob);
    return mergedpdfBase64
  }


  async function htc(demo: any) {
    return new Promise((rev, rej) => {
      html2canvas(demo, {
        allowTaint: true, //允许跨域
        height: demo?.scrollHeight, //
        width: 1000, //为了使横向滚动条的内容全部展示，这里必须指定
    //     background: "#FFFFFF", //如果指定的div没有设置背景色会默认成黑色
        // dpi: 300,
        scale: 1.2,
        backgroundColor: '#FFFFFF',
        useCORS: true, //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      }).then((canvas) => {
        let pdf = new jsPDF('p', 'mm', 'a4'); //A4纸，纵向
        let ctx: any = canvas.getContext('2d'),
          a4w = 190,
          a4h = 277, //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          imgHeight = Math.floor(a4h * canvas.width / a4w), //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;
    
    
    

    
        while (renderedHeight < canvas.height) {
          let page: any = document.createElement("canvas");
          page.width = canvas.width;
          // console.log(imgHeight, canvas.height, renderedHeight, canvas.width)
          page.height = Math.min(imgHeight, canvas.height - renderedHeight); //可能内容不足一页
          //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(
            imgHeight, canvas.height - renderedHeight)), 0, 0);
          pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, 
            Math.min(a4h, a4w * page.height / page.width)
          ); //添加图像到页面，保留10mm边距
          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) pdf.addPage(); //如果后面还有内容，添加一个空页
        }
        let pdfData = pdf.output('dataurlstring')
        rev(pdfData)
      })
    })
    
  }

  async function elementToImage(element: HTMLElement) {
    const rect = element.getBoundingClientRect()
    const width = Math.ceil(rect.width)
    const height = Math.ceil(rect.height)
    const canvas = await html2canvas(element, {
      allowTaint: true,
      height,
      width,
      scale: 1.2,
      backgroundColor: '#FFFFFF',
      useCORS: true,
    })
    return {
      url: canvas.toDataURL('image/jpeg', 1.0),
      width,
      height,
    }
  }

  async function imageToDataUrl(src: string) {
    return new Promise<string>((resolve, reject) => {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.naturalWidth || img.width
        canvas.height = img.naturalHeight || img.height
        canvas.getContext('2d')?.drawImage(img, 0, 0)
        resolve(canvas.toDataURL('image/png'))
      }
      img.onerror = reject
      img.src = src
    })
  }

  function textToDataUrl(text: string, backgroundColor = '#1890ff') {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if(!ctx) return ''

    const fontSize = 18
    const paddingX = 8
    const paddingY = 6
    ctx.font = `500 ${fontSize}px Arial, "Microsoft YaHei", sans-serif`
    const metrics = ctx.measureText(text)
    const width = Math.ceil(metrics.width + paddingX * 2)
    const height = Math.ceil(fontSize + paddingY * 2)
    canvas.width = width
    canvas.height = height

    const radius = 6
    ctx.clearRect(0, 0, width, height)
    ctx.font = `500 ${fontSize}px Arial, "Microsoft YaHei", sans-serif`
    ctx.fillStyle = backgroundColor
    ctx.beginPath()
    ctx.moveTo(radius, 0)
    ctx.lineTo(width - radius, 0)
    ctx.quadraticCurveTo(width, 0, width, radius)
    ctx.lineTo(width, height - radius)
    ctx.quadraticCurveTo(width, height, width - radius, height)
    ctx.lineTo(radius, height)
    ctx.quadraticCurveTo(0, height, 0, height - radius)
    ctx.lineTo(0, radius)
    ctx.quadraticCurveTo(0, 0, radius, 0)
    ctx.closePath()
    ctx.fill()
    ctx.fillStyle = '#ffffff'
    ctx.textBaseline = 'middle'
    ctx.fillText(text, paddingX, height / 2 + 1)
    return canvas.toDataURL('image/png')
  }

  function appendPageHeader(container: HTMLElement, showHeader: boolean) {
    if(!showHeader) return

    let img = document.createElement("img")
    img.src = logo
    img.style.height = '60px'
    img.setAttribute("class", styles['page-logo-1'])
    container.appendChild(img)
    container.style.paddingTop = '170px'

    let div = document.createElement("div")
    div.innerText = title ? title.split(">").join(" ") : ''
    div.setAttribute("class", styles['sp'] + " " + (shownum === 3 ? styles['s3'] : ''))
    container.appendChild(div)
  }

  async function generateCardImagePDF(children: HTMLElement[], cols: number, titleBackgroundColor = '#1890ff') {
    const pdf = new jsPDF('p', 'mm', 'a4')
    const itemImages: Array<{ url: string; width: number; height: number }> = []
    const pageWidth = 210
    const pageHeight = 297
    const pageMargin = 10
    const contentWidth = 190
    const pxToMm = contentWidth / 1000
    const cardGap = 10 * pxToMm
    const startY = pageMargin + 150 * pxToMm
    const pageBottom = pageHeight - pageMargin
    const titleText = title ? title.split(">").join(" ") : ''
    let logoDataUrl = ''
    let titleDataUrl = ''
    let headerAdded = false

    try {
      logoDataUrl = await imageToDataUrl(logo)
    }catch(e) {
      logoDataUrl = ''
    }
    titleDataUrl = textToDataUrl(titleText, titleBackgroundColor)

    const addHeader = () => {
      if(headerAdded) return

      if(logoDataUrl) {
        const logoProps = pdf.getImageProperties(logoDataUrl)
        const logoW = 100 * pxToMm
        const logoH = logoProps.height ? logoW * (logoProps.height / logoProps.width) : logoW
        pdf.addImage(logoDataUrl, 'PNG', pageMargin, pageMargin + 40 * pxToMm, logoW, logoH)
      }
      if(titleDataUrl) {
        const titleProps = pdf.getImageProperties(titleDataUrl)
        const titleW = Math.min(titleProps.width * pxToMm, pageWidth - pageMargin * 2)
        const titleH = titleProps.width ? titleW * (titleProps.height / titleProps.width) : 0
        pdf.addImage(titleDataUrl, 'PNG', pageMargin, pageMargin + 108 * pxToMm, titleW, titleH)
      }

      headerAdded = true
    }

    for(let i = 0; i < children.length; i++) {
      itemImages.push(await elementToImage(children[i]))
      setProgress(Math.floor(((i + 1) / children.length) * 80))
    }

    addHeader()
    let currentY = startY

    for(let i = 0; i < itemImages.length; i += cols) {
      const rowItems = itemImages.slice(i, i + cols)
      const rowHeights = rowItems.map((item) => item.height * pxToMm)
      const rowHeight = Math.max(...rowHeights)
      const availablePageHeight = pageBottom - startY
      const rowScale = rowHeight > availablePageHeight ? availablePageHeight / rowHeight : 1
      const scaledRowHeight = rowHeight * rowScale

      if(currentY !== startY && currentY + scaledRowHeight > pageBottom) {
        pdf.addPage()
        headerAdded = false
        addHeader()
        currentY = startY
      }

      for(let col = 0; col < rowItems.length; col++) {
        const item = rowItems[col]
        const itemWidth = item.width * pxToMm * rowScale
        const itemHeight = item.height * pxToMm * rowScale
        const x = pageMargin + col * ((item.width * pxToMm) + cardGap)
        pdf.addImage(item.url, 'JPEG', x, currentY, itemWidth, itemHeight)
      }
      currentY += scaledRowHeight + cardGap
      setProgress(80 + Math.floor((Math.min(i + cols, itemImages.length) / itemImages.length) * 20))
    }

    return pdf.output('dataurlstring')
  }

  async function newgeneratePDF(id?: any) {


    setLoading(true)
    setProgress(0)
    //下载pdf方法
    let container: any = document.getElementById(id);
    // console.log(container.children[1].children)
    // console.log(container.style)

    let children: any = Array.from(container.children)

    
    
    let chunkSize = shownum === 2 ? 20 : 100; // 每批渲染5个子元素
    const canvasList = [];
    if(isdp && shownum === 2) {
      chunkSize = 9
    }

    if(shownum === 2 || shownum === 3) {
      const cols = shownum === 2 && isdp ? 3 : 4
      const pdfData = await generateCardImagePDF(children, cols, shownum === 3 ? '#333333' : '#1890ff')
      const url = await mergePDFsToBase64([pdfData])
      setLoading(false)
      setProgress(0)
      downloadFile(url)
      setTimeout(() => {
        URL.revokeObjectURL(url)
      })
      return false
    }

    // 分批处理子元素
    for (let i = 0; i < children.length; i += chunkSize) {
      // 创建临时容器，仅包含当前批次的元素
      const tempContainer = document.createElement('div');
      tempContainer.setAttribute("class", styles['products'])
      if(shownum === 2 || shownum === 3) {
        appendPageHeader(tempContainer, true)
      }else {
        if(i === 0) {
          let img = document.createElement("img")
          img.src = logo
          img.style.height = '60px'
          img.setAttribute("class", styles['page-logo'])
          tempContainer.appendChild(img)
          tempContainer.style.paddingTop = '170px'
          let div = document.createElement("div")
          div.innerText = title ? title.split(">").join(" ") : ''
          div.setAttribute("class", styles['sp'])
          tempContainer.appendChild(div)
        }
      }
      for (let j = i; j < i + chunkSize && j < children.length; j++) {
        tempContainer.appendChild(children[j].cloneNode(true));
      }
      document.body.appendChild(tempContainer); // 临时添加到页面

      let canvasUrl = await htc(tempContainer)
      canvasList.push(canvasUrl)
      document.body.removeChild(tempContainer)
    }
    let url = await mergePDFsToBase64(canvasList)
    setLoading(false)
    setProgress(0)
    downloadFile(url)
    setTimeout(() => {
      URL.revokeObjectURL(url)
    })
    return false
  }

  

  let lang = window.localStorage.getItem('lang') === 'zh' ? 'cn' : window.localStorage.getItem('lang')
  return (
    <Modal
      title={
        <div className="flex-b-c">
          <div className="flex-s-c">
            <label className="mr20">{intl.formatMessage({ id: '预览' })}</label>
            {/* <Radio.Group
              options={
                [
                  {
                    label: intl.formatMessage({ id: '样式1' }),
                    value: 2
                  },
                  {
                    label: intl.formatMessage({ id: '样式2' }),
                    value: 1
                  },
                ]
              }
              value={shownum}
              onChange={(e) => setShownum(e.target.value)}
            >
            </Radio.Group> */}
          </div>
          <div className="flex-s-c">
            {
              (shownum === 2 || shownum === 3) && loading ? (
                <Progress type="circle" percent={progress} size={36} />
              ) : null
            }
            <Button type="primary" className="mr30 ml10" loading={loading} onClick={() => newgeneratePDF('pdfContent')}>{intl.formatMessage({ id: '导出' })}</Button>
          </div>
        </div>
      }
      open={true}
      onCancel={() => setOpen(false)}
      destroyOnClose
      footer={null}
      width={1100}
      
    >
      <div className={styles['pdfcon']} id="pdfcon" >
        {
          shownum === 3 ? (
            <>
              <div className={styles['page-logo-1']} style={{ left: 20 }}>
                <img style={{ height: 60 }} src={logo} />
              </div>
              <div  style={{ marginTop: 100 }}>
                <div className="flex-s-c">
                  <div className="plr15 ptb5" style={{ background: 'black', color: '#fff', borderRadius: 8, fontSize: 18, fontWeight: 500 }}>
                    {title ? title.split(">").join(" ") : ''}
                  </div>
                </div>
                <div id="pdfContent" className={styles['products']} style={{ marginTop: 20, width: 1000 }}>
                  {
                    list.map((item: any, index: number) => {
                      return (
                        <div className={styles['product-card-3']} key={index}>
                          <div className={styles['img-wrap'] + ' flex-c-c'}>
                            {
                              colSelect.includes("img") && item.img ? (
                                <img className={styles['img-1']} src={item.img} />
                              ): null
                            }
                          </div>
                          <div className={styles['product-card-3-content'] + ' p10'}>
                            {
                              colSelect.includes("part_name") ? (
                                <h3>{item.part_name}</h3>
                              ): null
                            }
                            {
                              partlangkey !== lang ? (
                                <h3>{colSelect.includes("part_name") && partnameData[item.part_name] && item.part_name ? partnameData[item.part_name][partlangkey] : ''}</h3>
                              ): null
                            }
                            {
                              colSelect.includes("quality_name") ? (
                                <div className={styles["product-props"]}>
                                  <span style={{ width: 50 }} className={styles["prop-label"]}>{intl.formatMessage({ id: '品牌' })}:</span>
                                  <span className={styles["prop-value"]}>{item.quality_name}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("quality_oe") ? (
                                <div className={styles["product-props"]}>
                                  <span style={{ width: 50 }} className={styles["prop-label"]}>{intl.formatMessage({ id: 'OE' })}:</span>
                                  <span className={styles["prop-value"]}>{item.quality_oe}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("params") ? (
                                <div className={styles["product-props"]}>
                                  <span style={{ width: 50 }} className={styles["prop-label"]}>{intl.formatMessage({ id: '规格' })}:</span>
                                  <span className={styles["prop-value"]} style={{ wordBreak: 'break-all' }}>{item.params}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("remark") ? (
                                <div className={styles["product-props"]}>
                                  <span style={{ width: 50 }} className={styles["prop-label"]}>{intl.formatMessage({ id: '备注' })}:</span>
                                  <span className={styles["prop-value"]}>{item.remark}</span>
                                </div>
                              ): null
                            }
                            <div className="flex-s-c" style={{ fontSize: 15, fontWeight: 500 }}>
                              <div>{isSen ? intl.formatMessage({ id: '自编码' }) : intl.formatMessage({ id: '编码' })}:</div>
                              {
                                colSelect.includes('code') && item.codes && item.codes.length ? item.codes.map((code: string, index: number) => {
                                  return (
                                    <div key={index}>{code}</div>
                                  )
                                }) : null
                              }
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </>
          ) : shownum === 2 ? (
            <>
              <div className={styles['page-logo-1']} style={{ left: 20 }}>
                <img style={{ height: 60 }} src={logo} />
              </div>
              <div  style={{ marginTop: 100 }}>
                <div className="flex-s-c">
                  <div className="plr15 ptb5" style={{ background: '#1890ff', color: '#fff', borderRadius: 8, fontSize: 18, fontWeight: 500 }}>
                    {title ? title.split(">").join(" ") : ''}
                  </div>
                </div>
                <div id="pdfContent" className={styles['products']} style={{ marginTop: 20, width: 1000 }}>
                  {
                    classList.map((item: any, index: number) => {
                      return (
                        <div className={styles["product-card-1"] +  ' ' + `${isdp ? styles['product-card-1-dp'] : ''}`} key={index}>
                          <div className="flex plr10" style={{ justifyContent: 'space-between' }}>
                            <div>
                              {
                                item.part_name ? (
                                  <div className="p-color">{item.main_group || ""}</div>
                                ): null
                              }
                              <div>{item.part_name ? dph : ''} {colSelect.includes("part_name") && item.part_name ? item.part_name : ''}</div>
                              {
                                partlangkey !== lang ? (
                                  <div>{colSelect.includes("part_name") && partnameData[item.part_name] && item.part_name ? partnameData[item.part_name][partlangkey] : ''}</div>
                                ): null
                              }
                              {/* <div>{colSelect.includes("code") && item.code ? item.code : ''}</div> */}
                              <div>
                                {
                                  colSelect.includes('code') && item.codes && item.codes.length ? item.codes.map((code: string, index: number) => {
                                    return (
                                      <div key={index}>{code}</div>
                                    )
                                  }) : null
                                }
                              </div>
                            </div>
                            <img  className={styles['logo-1'] + ' ml10'} src={logo} />
                          </div>
                          <div className="flex-c-c">
                            {
                              colSelect.includes("img") && item.img ? (
                                <img className={styles['img-1']} src={item.img} />
                              ): null
                            }
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              
            </>
          ): (
            <>
              <div className={styles['page-logo']}>
                <img style={{ height: 60 }} src={logo} />
              </div>
              <div className="flex-s-c" style={{ paddingTop: 50 }}>
                <div className="plr15 ptb5" style={{ background: '#1890ff', color: '#fff', borderRadius: 8, fontSize: 18, fontWeight: 500 }}>
                  {title ? title.split(">").join(" ") : ''}
                </div>
              </div>
              <div className={styles['products']} id="pdfContent">
                {
                  list.map((item: any, index: number) => {
                    return (
                      <div className={styles["product-card"]} key={index}>
                        {
                          colSelect.includes("part_name") ? (
                            <h3>{item.part_name}</h3>
                          ): null
                        }
                        {
                          partlangkey !== lang ? (
                            <h3>{colSelect.includes("part_name") && partnameData[item.part_name] && item.part_name ? partnameData[item.part_name][partlangkey] : ''}</h3>
                          ): null
                        }
                        <div style={{ borderTop: '2px solid #ff7f00' }} className="flex-b-c">
                          <div >
                            {
                              item.part_name && item.main_group ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '分类' })}:</span>
                                  <span className={styles["prop-value"] + ' p-color'} style={{ color: '#096BED' }}>{item.main_group}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("quality_oe") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '原厂OE' })}:</span>
                                  <span className={styles["prop-value"]}>{item.quality_oe}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("code") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '产品编码' })}:</span>
                                  <span className={styles["prop-value"]}>{item.code}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("warranty") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '质保时间' })}:</span>
                                  <span className={styles["prop-value"]}>{item.warranty}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("quality_name") && colSelect.includes("quality_price") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '销售价格' })}:</span>
                                  <span className={styles["prop-value"]}>{item.quality_name}: ¥{item.quality_price}</span>
                                </div>
                              ): null
                            }
                            {
                              colSelect.includes("params") ? (
                                <div className={styles["product-props"]}>
                                  <span className={styles["prop-label"]}>{intl.formatMessage({ id: '产品参数' })}:</span>
                                  <span className={styles["prop-value"]}>{item.params}</span>
                                </div>
                              ): null
                            }
                          </div>
                          {
                            colSelect.includes("img") ? (
                              <div className={styles["product-img"]}>
                                <img src={item.img}  />
                              </div>
                            ): null
                          }
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </>
          )
        }

        
      </div>
    </Modal>
    
  )
}

export default Pdfcon
